import React from 'react'
import MainTitle from '../common/MainTitle'
import GeneralResult from './GeneralResult'
import OpenQuestion from './OpenQuestion'
import { Fragment } from 'react';
import CustomHr from '../common/CustomHr'


const GeneralResults = ({ results, session, index, playedTimes, selectedName }) => {

    const criterias = session.data.msCriterias


    return (
        <div>
            {criterias.map((criteria, i) => {
                let orderedResult = results
                console.log("orderedResult", orderedResult);
                
                let name = criteria.name
                if (criteria.minCaption) {
                    name = `${criteria.name} (${criteria.minCaption} - ${criteria.maxCaption})`;
                }
            
                if (selectedName) {
                    orderedResult = orderedResult.map(res => {
                        if (res[criteria.name] && res[criteria.name].scores) {
                            const filteredScores = res[criteria.name].scores.filter(score => score.participantName === selectedName);
                            const score = filteredScores.length > 0 ? filteredScores[0].score : 0;
                            return { ...res, [criteria.name]: { ...res[criteria.name], scores: filteredScores, total: score } };
                        }
                        return res;
                    });
                }
            
                orderedResult.sort((a, b) => {
                    const scoreA = a[criteria.name]?.total || 0;
                    const scoreB = b[criteria.name]?.total || 0;
                    return scoreB - scoreA;
                });

                return (
                    <div key={i}>
                        <MainTitle text={name} />
                        <div className="row margin-bottom-large">
                            {!criteria.type || criteria.type === 'CLOSE'
                                ?
                                <Fragment>
                                    {/* eslint-disable-next-line */}
                                    {orderedResult.map((res, y) => {
                                        if (res.resource) {
                                            return (
                                                <GeneralResult
                                                    key={`${i}-${y}`}
                                                    result={res[criteria.name]}
                                                    rank={y + 1}
                                                    maximum={playedTimes}
                                                    resource={res.resource}
                                                    selectedName={selectedName}
                                                />
                                            )
                                        }
                                    })}
                                </Fragment>
                                :
                                <Fragment>
                                    {/* eslint-disable-next-line */}
                                    {orderedResult.map((res, y) => {
                                        if (res.resource) {
                                            return (
                                                <OpenQuestion
                                                    key={`${i}-${y}`}
                                                    results={res[criteria.name]}
                                                    resource={res.resource}
                                                    isLast={y === orderedResult.length - 1}
                                                    selectedName={selectedName}
                                                />
                                            )
                                        }
                                    })}
                                </Fragment>}
                        </div>
                        <CustomHr />
                    </div>
                )
            }
            )}
        </div>
    )
}

export default GeneralResults
